import { Injectable } from '@angular/core';
import { ISettingsService, SettingAccessor } from '../ISettingsService';
import { firstValueFrom } from 'rxjs';
import { ApiDataService } from '@kw-shared/api-data-access';
import { ObjectKeys } from '../../../../../apps/keba-wallbox-app/src/plugins/keba-wallbox-plugin';
import { WallboxAppConfiguration } from '../../../../../apps/keba-wallbox-app/src/app/services/local-wallbox/settings/local-wallbox-settings.service';

@Injectable({
  providedIn: 'root',
})
export class RemoteSettingsService implements ISettingsService {
  constructor(private readonly apiDataService: ApiDataService) {}

  public async readSetting(
    settingAccessor: SettingAccessor,
    wallboxId: string
  ): Promise<string | string[] | undefined | ObjectKeys> {
    let settings = await firstValueFrom(this.apiDataService.wallboxes.getWallboxSettings(wallboxId));
    if (settingAccessor.settingKey && settings.configuration.hasOwnProperty(settingAccessor.settingKey)) {
      return settings.configuration[settingAccessor.settingKey] ?? '';
    }

    return undefined;
  }

  public getWallboxConfig(): WallboxAppConfiguration | undefined {
    throw new Error('Method not implemented.');
  }
}
